import { render, staticRenderFns } from "./inviteMember.vue?vue&type=template&id=2e70e79b&scoped=true"
import script from "./inviteMember.vue?vue&type=script&lang=js"
export * from "./inviteMember.vue?vue&type=script&lang=js"
import style0 from "./inviteMember.vue?vue&type=style&index=0&id=2e70e79b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70e79b",
  null
  
)

export default component.exports